import { memo, useMemo } from 'react';

import { Text } from '@betty/moonlight';
import { Trans } from '@betty/i18n';
import { formatDate } from '@betty/toolkit/utils';
import { StatusResetDisclaimerProps } from './types';

function StatusResetDisclaimer({ status }: StatusResetDisclaimerProps) {
  const { keepStatusNumberOfBoxes } = status;

  const transComponents = useMemo(
    () => ({
      highlight: <Text variant="caption-semi" color="darkSurfaceTertiary" />,
    }),
    [],
  );

  if (!status.expiryDate) {
    return null;
  }

  const date = formatDate(status.expiryDate, 'MMM DD, YYYY @ ha');

  return (
    <Text variant="caption" color="darkSurfaceMuted" textAlign="center">
      <Trans
        ns="status"
        i18nKey={
          keepStatusNumberOfBoxes === 1 ? 'disclaimer_one' : 'disclaimer_other'
        }
        components={transComponents}
        values={{ date, keepStatusNumberOfBoxes }}
      />
    </Text>
  );
}

export default memo(StatusResetDisclaimer);
